module.exports = __webpack_public_path__ + "static/media/lab_detail.f71d9405.svg";